"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE_TO_FILTER_MAPPING = exports.FILTER_ORDER_MAPPING = exports.GROUP_FILTER_TEMPLATE_BY_FILTER_ID = void 0;
var tslib_1 = require("tslib");
var search_1 = require("src/search");
var FilterTypings_1 = require("Views/Partials/Components/Filters/FilterTypings");
var segmentFilterTemplate = {
    guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
    newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
    isCollapsed: false,
    isSearchable: false,
    titleProp: '',
    typeAlias: FilterTypings_1.FilterGroupTypeAlias.Segment,
};
exports.GROUP_FILTER_TEMPLATE_BY_FILTER_ID = (_a = {},
    _a[search_1.FullTextSearchFilters.TypeFilterId] = {
        filters: [
            { type: search_1.FullTextSearcherTypes.Products, labelProp: 'productsLabel', priority: 1 },
            { type: search_1.FullTextSearcherTypes.Documentation, labelProp: 'documentationLabel', priority: 2 },
            { type: search_1.FullTextSearcherTypes.Drawings, labelProp: 'drawingsLabel', priority: 3 },
            { type: search_1.FullTextSearcherTypes.Download, labelProp: 'downloadsLabel', priority: 4 },
            { type: search_1.FullTextSearcherTypes.Careers, labelProp: 'careersLabel', priority: 5 },
            { type: search_1.FullTextSearcherTypes.Course, labelProp: 'courseLabel', priority: 6 },
        ],
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'type',
        type: search_1.FullTextSearchFilters.TypeFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Type,
        value: search_1.FullTextSearchFilters.TypeFilterAlias,
        unselectable: true,
    },
    /////////////////////////
    // ALL RESULTS FILTERS //
    _a[search_1.FullTextSearchFilters.AllSegmentFilterId] = tslib_1.__assign(tslib_1.__assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.AllSegmentFilterAlias, value: search_1.FullTextSearchFilters.AllSegmentFilterAlias }),
    ///////////////////////////
    // DOCUMENTATION FILTERS //
    _a[search_1.FullTextSearchFilters.DocumentationSegmentFilterId] = tslib_1.__assign(tslib_1.__assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.DocumentationSegmentFilterAlias, value: search_1.FullTextSearchFilters.DocumentationSegmentFilterAlias }),
    _a[search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'documentTypes',
        type: search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationProductionSiteId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'productionSite',
        type: search_1.FullTextSearchFilters.DocumentationProductionSiteAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductionSite,
        value: search_1.FullTextSearchFilters.DocumentationProductionSiteAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        isHidden: true,
        isDisabled: false,
        titleProp: 'approvalType',
        type: search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationLanguageFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: true,
        isSearchable: false,
        titleProp: 'languages',
        type: search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationCountryFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        labelProp: 'validForLabel',
        placeholder: 'validForAllCountries',
        titleProp: 'country',
        type: search_1.FullTextSearchFilters.DocumentationCountryFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationCountryFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationHierarchyFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Hierarchy,
        value: search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy,
        value: search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationProductSeriesFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productSeries',
        type: search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductSeries,
        value: search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationAuthorityFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'authorityLabel',
        titleProp: 'authority',
        type: search_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias,
        value: search_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationProductGroupFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productGroup',
        type: search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductGroup,
        value: search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DocumentationArchivedFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'archivedGroup',
        type: search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Archived,
        value: search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
    },
    //////////////////////
    // PRODUCTS FILTERS //
    _a[search_1.FullTextSearchFilters.ProductsSegmentFilterId] = tslib_1.__assign(tslib_1.__assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.ProductsSegmentFilterAlias, value: search_1.FullTextSearchFilters.ProductsSegmentFilterAlias }),
    //////////////////////
    // DOWNLOAD FILTERS //
    _a[search_1.FullTextSearchFilters.DownloadSegmentFilterId] = tslib_1.__assign(tslib_1.__assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.DownloadSegmentFilterAlias, value: search_1.FullTextSearchFilters.DownloadSegmentFilterAlias }),
    _a[search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        placeholder: 'downloadSoftwareType',
        titleProp: 'downloadSoftwareType',
        type: search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        placeholder: 'downloadSoftwareCharacteristic',
        titleProp: 'downloadSoftwareCharacteristic',
        type: search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias,
        value: search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DownloadProductGroupFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productGroup',
        type: search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductGroup,
        value: search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DownloadProductSeriesFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productSeries',
        type: search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductSeries,
        value: search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias,
    },
    /////////////////////
    // CAREERS FILTERS //
    _a[search_1.FullTextSearchFilters.CareersCountryFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: true,
        placeholder: 'country',
        titleProp: 'country',
        type: search_1.FullTextSearchFilters.CareersCountryFilterAlias,
        value: search_1.FullTextSearchFilters.CareersCountryFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.CareersLocationFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isDisabled: true,
        isHidden: true,
        isSearchable: false,
        titleProp: 'location',
        placeholder: 'location',
        type: search_1.FullTextSearchFilters.CareersLocationFilterAlias,
        value: search_1.FullTextSearchFilters.CareersLocationFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.CareersJobAreaFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'jobArea',
        type: search_1.FullTextSearchFilters.CareersJobAreaFilterAlias,
        value: search_1.FullTextSearchFilters.CareersJobAreaFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.CareersExperienceLevelFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'experienceLevel',
        type: search_1.FullTextSearchFilters.CareersExperienceLevelFilterAlias,
        value: search_1.FullTextSearchFilters.CareersExperienceLevelFilterAlias,
    },
    ////////////////////
    // COURSE FILTERS //
    _a[search_1.FullTextSearchFilters.CourseSegmentFilterId] = tslib_1.__assign(tslib_1.__assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.CourseSegmentFilterAlias, value: search_1.FullTextSearchFilters.CourseSegmentFilterAlias }),
    _a[search_1.FullTextSearchFilters.CourseLanguageFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isDisabled: false,
        isHidden: false,
        isSearchable: false,
        titleProp: 'languages',
        type: search_1.FullTextSearchFilters.CourseLanguageFilterAlias,
        value: search_1.FullTextSearchFilters.CourseLanguageFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.CourseHierarchyFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isDisabled: true,
        isHidden: true,
        isSearchable: false,
        labelProp: 'courseCategory',
        placeholder: 'courseCategory',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.CourseHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Hierarchy,
        value: search_1.FullTextSearchFilters.CourseHierarchyFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.CourseLearningEventTypeFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: true,
        isSearchable: true,
        titleProp: 'learningEventType',
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.LearningEventType,
        type: search_1.FullTextSearchFilters.CourseLearningEventTypeFilterAlias,
        value: search_1.FullTextSearchFilters.CourseLearningEventTypeFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.CourseDeliveryTypesFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isDisabled: false,
        isHidden: false,
        isSearchable: false,
        titleProp: 'offeredAs',
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.DeliveryTypes,
        type: search_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias,
        value: search_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias,
    },
    ////////////////////
    // DRAWINGS FILTERS //
    _a[search_1.FullTextSearchFilters.DrawingsSegmentFilterId] = tslib_1.__assign(tslib_1.__assign({}, segmentFilterTemplate), { type: search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias, value: search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias }),
    _a[search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'drawingType',
        type: search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias,
        value: search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DrawingsLanguageFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Checkbox,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.DropdownMulti,
        isCollapsed: true,
        isSearchable: false,
        titleProp: 'languages',
        type: search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias,
        value: search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DrawingsArchivedFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Radio,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        titleProp: 'archivedGroup',
        type: search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.Archived,
        value: search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DrawingsProductSeriesFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productSeries',
        type: search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductSeries,
        value: search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DrawingsProductGroupFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Dropdown,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'productGroup',
        type: search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductGroup,
        value: search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias,
    },
    _a[search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterId] = {
        guiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        newSearchGuiType: FilterTypings_1.FilterGroupGuiTypeEnum.Hierarchy,
        isCollapsed: false,
        isSearchable: false,
        labelProp: 'productHierarcyLabel',
        titleProp: 'hierarchy',
        type: search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias,
        typeAlias: FilterTypings_1.FilterGroupTypeAlias.ProductHierarchy,
        value: search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias,
    },
    _a);
exports.FILTER_ORDER_MAPPING = (_b = {
        default: (_c = {},
            _c[search_1.FullTextSearchFilters.TypeFilterId] = 1,
            _c[search_1.FullTextSearchFilters.AllSegmentFilterId] = 2,
            _c)
    },
    _b[search_1.FullTextSearcherTypes.Documentation] = (_d = {},
        _d[search_1.FullTextSearchFilters.TypeFilterId] = 1,
        _d[search_1.FullTextSearchFilters.DocumentationSegmentFilterId] = 2,
        _d[search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterId] = 3,
        _d[search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterId] = 4,
        _d[search_1.FullTextSearchFilters.DocumentationLanguageFilterId] = 5,
        _d[search_1.FullTextSearchFilters.DocumentationCountryFilterId] = 6,
        _d[search_1.FullTextSearchFilters.DocumentationHierarchyFilterId] = 7,
        _d[search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterId] = 8,
        _d[search_1.FullTextSearchFilters.DocumentationProductGroupFilterId] = 9,
        _d[search_1.FullTextSearchFilters.DocumentationProductSeriesFilterId] = 10,
        _d[search_1.FullTextSearchFilters.DocumentationArchivedFilterId] = 11,
        _d[search_1.FullTextSearchFilters.DocumentationAuthorityFilterId] = 12,
        _d[search_1.FullTextSearchFilters.DocumentationProductionSiteId] = 13,
        _d),
    _b[search_1.FullTextSearcherTypes.Products] = (_e = {},
        _e[search_1.FullTextSearchFilters.TypeFilterId] = 1,
        _e[search_1.FullTextSearchFilters.ProductsSegmentFilterId] = 2,
        _e),
    _b[search_1.FullTextSearcherTypes.Download] = (_f = {},
        _f[search_1.FullTextSearchFilters.TypeFilterId] = 1,
        _f[search_1.FullTextSearchFilters.DownloadSegmentFilterId] = 2,
        _f[search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterId] = 3,
        _f[search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterId] = 4,
        _f[search_1.FullTextSearchFilters.DownloadProductGroupFilterId] = 5,
        _f[search_1.FullTextSearchFilters.DownloadProductSeriesFilterId] = 6,
        _f),
    _b[search_1.FullTextSearcherTypes.Careers] = (_g = {},
        _g[search_1.FullTextSearchFilters.TypeFilterId] = 1,
        _g[search_1.FullTextSearchFilters.CareersCountryFilterId] = 2,
        _g[search_1.FullTextSearchFilters.CareersLocationFilterId] = 3,
        _g[search_1.FullTextSearchFilters.CareersJobAreaFilterId] = 4,
        _g[search_1.FullTextSearchFilters.CareersExperienceLevelFilterId] = 5,
        _g),
    _b[search_1.FullTextSearcherTypes.Course] = (_h = {},
        _h[search_1.FullTextSearchFilters.TypeFilterId] = 1,
        _h[search_1.FullTextSearchFilters.CourseSegmentFilterId] = 2,
        _h[search_1.FullTextSearchFilters.CourseLanguageFilterId] = 3,
        _h[search_1.FullTextSearchFilters.CourseHierarchyFilterId] = 4,
        _h[search_1.FullTextSearchFilters.CourseLearningEventTypeFilterId] = 5,
        _h[search_1.FullTextSearchFilters.CourseDeliveryTypesFilterId] = 6,
        _h),
    _b[search_1.FullTextSearcherTypes.Drawings] = (_j = {},
        _j[search_1.FullTextSearchFilters.TypeFilterId] = 1,
        _j[search_1.FullTextSearchFilters.DrawingsSegmentFilterId] = 2,
        _j[search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterId] = 3,
        _j[search_1.FullTextSearchFilters.DrawingsLanguageFilterId] = 4,
        _j[search_1.FullTextSearchFilters.DrawingsArchivedFilterId] = 5,
        _j[search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterId] = 6,
        _j[search_1.FullTextSearchFilters.DrawingsProductGroupFilterId] = 7,
        _j[search_1.FullTextSearchFilters.DrawingsProductSeriesFilterId] = 8,
        _j),
    _b);
exports.TYPE_TO_FILTER_MAPPING = (_k = {},
    _k[search_1.FullTextSearcherTypes.All] = [search_1.FullTextSearchFilters.AllSegmentFilterAlias],
    _k[search_1.FullTextSearcherTypes.Documentation] = [
        search_1.FullTextSearchFilters.DocumentationSegmentFilterAlias,
        search_1.FullTextSearchFilters.DocumentationDocumentTypeFilterAlias,
        search_1.FullTextSearchFilters.DocumentationApprovalTypeFilterAlias,
        search_1.FullTextSearchFilters.DocumentationLanguageFilterAlias,
        search_1.FullTextSearchFilters.DocumentationCountryFilterAlias,
        search_1.FullTextSearchFilters.DocumentationHierarchyFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductHierarchyFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductGroupFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductSeriesFilterAlias,
        search_1.FullTextSearchFilters.DocumentationAuthorityFilterAlias,
        search_1.FullTextSearchFilters.DocumentationArchivedFilterAlias,
        search_1.FullTextSearchFilters.DocumentationProductionSiteAlias,
    ],
    _k[search_1.FullTextSearcherTypes.Products] = [search_1.FullTextSearchFilters.ProductsSegmentFilterAlias],
    _k[search_1.FullTextSearcherTypes.Download] = [
        search_1.FullTextSearchFilters.DownloadSegmentFilterAlias,
        search_1.FullTextSearchFilters.DownloadSoftwareTypeFilterAlias,
        search_1.FullTextSearchFilters.DownloadSoftwareCharacteristicFilterAlias,
        search_1.FullTextSearchFilters.DownloadProductGroupFilterAlias,
        search_1.FullTextSearchFilters.DownloadProductSeriesFilterAlias,
    ],
    _k[search_1.FullTextSearcherTypes.Careers] = [
        search_1.FullTextSearchFilters.CareersCountryFilterAlias,
        search_1.FullTextSearchFilters.CareersLocationFilterAlias,
        search_1.FullTextSearchFilters.CareersJobAreaFilterAlias,
        search_1.FullTextSearchFilters.CareersExperienceLevelFilterAlias,
    ],
    _k[search_1.FullTextSearcherTypes.Course] = [
        search_1.FullTextSearchFilters.CourseSegmentFilterAlias,
        search_1.FullTextSearchFilters.CourseHierarchyFilterAlias,
        search_1.FullTextSearchFilters.CourseLanguageFilterAlias,
        search_1.FullTextSearchFilters.CourseLearningEventTypeFilterAlias,
        search_1.FullTextSearchFilters.CourseDeliveryTypesFilterAlias,
    ],
    _k[search_1.FullTextSearcherTypes.Drawings] = [
        search_1.FullTextSearchFilters.DrawingsSegmentFilterAlias,
        search_1.FullTextSearchFilters.DrawingsDrawingTypeFilterAlias,
        search_1.FullTextSearchFilters.DrawingsLanguageFilterAlias,
        search_1.FullTextSearchFilters.DrawingsArchivedFilterAlias,
        search_1.FullTextSearchFilters.DrawingsProductGroupFilterAlias,
        search_1.FullTextSearchFilters.DrawingsProductSeriesFilterAlias,
        search_1.FullTextSearchFilters.DrawingsProductHierarchyFilterAlias,
    ],
    _k);
